<template>
  <div class="page_backgroundCheckRecord">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="screenInputs">
          <div class="screenInput" v-if="activeName == 'third'">
            <div class="flname" style="width:68px">项目名称:</div>
            <el-input v-model="listQuery.name" size="small" clearable style="width:200px" @keyup.enter.native="searchHandle"></el-input>
            <el-button v-if="activeName == 'third'" type="success" size="small" icon="el-icon-search" @click="searchHandle" style="margin-left:24px">&nbsp;搜索</el-button>
          </div>
          <div class="screenInput" v-if="activeName == 'second'">
            <div class="flname" style="width:68px">项目名称:</div>
            <el-input v-model="listQuery.name" size="small" clearable style="width:200px" @keyup.enter.native="searchHandle"></el-input>
            <el-button v-if="activeName == 'second'" type="success" size="small" icon="el-icon-search" @click="searchHandle" style="margin-left:24px">&nbsp;搜索</el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>产品</el-breadcrumb-item>
          <el-breadcrumb-item>小杰闪查</el-breadcrumb-item>
          <el-breadcrumb-item>闪查管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane v-if="checkPermission(['bgSet_customer_manage'],permissionLists)" label="闪查客户管理" name="third"></el-tab-pane>
          <el-tab-pane v-if="checkPermission(['bgSet_project_manage'],permissionLists)" label="内部项目闪查管理" name="second"></el-tab-pane>
          <el-tab-pane v-if="checkPermission(['bgSet_product_manage'],permissionLists)" label="闪查产品管理" name="first"></el-tab-pane>
          <el-tab-pane v-if="checkPermission(['bgSet_customer_manage'],permissionLists)" label="客户消费明细" name="four"></el-tab-pane>
          <el-tab-pane v-if="checkPermission(['bgSet_customer_manage'],permissionLists)" label="客户订单" name="five"></el-tab-pane>
          <el-tab-pane v-if="checkPermission(['bgSet_customer_manage'],permissionLists)" label="申请试用列表" name="six"></el-tab-pane>
        </el-tabs>
        <!-- <div v-if="activeName=='first'" style="margin-bottom: 10px;display: flex;flex-direction: row-reverse;">
          <el-button type="success" size="small" style="margin-right:24px" @click="visibleProductSet = true" icon="el-icon-plus">新增产品</el-button>
        </div> -->
        <div class="bgset_btn">
          <!-- <el-button :loading="thirdLoading" type="primary" size="small" v-if="activeName=='third'&&(!isNull(tableData))" @click="addNewCust">导出</el-button> -->
          <!-- <el-button :loading="thirdLoading" type="primary" size="small" v-if="activeName=='second'&&(!isNull(customerList))" @click="addNewCust">导出</el-button> -->
          <el-button type="success" icon="el-icon-document-add" size="small" v-if="activeName=='third'" @click="exportList()">&nbsp;导出列表</el-button>
          <el-button type="success" icon="el-icon-document-add" size="small" v-if="activeName=='six'" @click="exportListTrial()">&nbsp;导出申请试用列表</el-button>
          <el-button type="success" icon="el-icon-document-add" size="small" v-if="activeName=='third'&&(checkPermission(['bgSet_add_customer'],permissionLists))" @click="addNewCust">&nbsp;新建闪查客户</el-button>
        </div>
        <el-table v-if="activeName=='first'" :data="tableData" border style="width: 100%">
          <el-table-column prop="name" align="center" label="产品" width="120">
          </el-table-column>
          <el-table-column prop="name" label="项目">
            <template slot-scope="scope">
              <div class="checkBox flex">
                <div :class="index>2 ? 'checkItem cp flex sb mt' : 'checkItem cp flex sb'" v-for="(item,index) in scope.row.productList" :key="index">
                  <div style="width: 100%;" class="flex aic">
                    <!-- <img :src="item.icon" alt="" class="icon"> -->
                    <div style="padding-left: 15px;"> {{ item.Product }}</div>
                    <div class="price"> ￥{{ item.Price }}</div>
                  </div>
                  <i v-if="checkPermission(['bgSet_product_sets'],permissionLists)" class="el-icon-setting" title="设置" @click="setPro(item,scope.row)"></i>
                  <!-- <i class="el-icon-delete" title="删除" @click="dltPro(item,scope.row)"></i> -->
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="proName" align="center" label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="success" size="small" style="margin-right:10px" icon="el-icon-plus" @click="addNewPro(scope.row)">新增项目</el-button>
            </template>
          </el-table-column> -->
        </el-table>

        <div class="bgTable">
          <el-table v-if="activeName=='second' || activeName=='third'" :data="customerList" style="width: 100%" class="doc_table" border v-loading="isLoading">
            <el-table-column v-if="activeName=='second'" prop="StrprojectName" align="center" label="项目名称" :show-overflow-tooltip="true" min-width="140"></el-table-column>
            <el-table-column v-if="activeName=='second'" prop="StrCustShortName" align="center" label="客户简称" :show-overflow-tooltip="true" min-width="140">
            </el-table-column>
            <el-table-column v-if="activeName=='second'" prop="StrCustName" align="center" label="客户名称" :show-overflow-tooltip="true" min-width="140">
            </el-table-column>
            <el-table-column v-if="activeName=='second'" prop="name3" align="center" label="所属集团名称" :show-overflow-tooltip="true" min-width="140">
            </el-table-column>
            <el-table-column v-if="activeName=='second'" prop="Amount" align="center" label="余额" :show-overflow-tooltip="true" min-width="80">
            </el-table-column>
            <el-table-column v-if="activeName=='second'" prop="AmountSpent" align="center" label="累计消费" :show-overflow-tooltip="true" min-width="80">
            </el-table-column>
            <el-table-column v-if="activeName=='second'" prop="PayTotalAmount" align="center" label="累计充值" :show-overflow-tooltip="true" min-width="80">
            </el-table-column>
            <el-table-column v-if="activeName=='second'" prop="productname" align="center" label="项目权限">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.productname" placement="top">
                  <div class="text-ellipsis">{{ scope.row.productname }}</div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column v-if="activeName=='third'" prop="Project" align="center" label="项目名称" :show-overflow-tooltip="true" min-width="140"></el-table-column>
            <el-table-column v-if="activeName=='third'" prop="ShortName" align="center" label="客户简称" :show-overflow-tooltip="true" min-width="140">
            </el-table-column>
            <el-table-column v-if="activeName=='third'" prop="Name" align="center" fixed="left" label="客户名称" :show-overflow-tooltip="true" min-width="140">
            </el-table-column>
            <el-table-column v-if="activeName=='third'" prop="GroupName" align="center" label="所属集团名称" :show-overflow-tooltip="true" min-width="140">
            </el-table-column>
            <el-table-column v-if="activeName=='third'" prop="Amount" align="center" label="余额" :show-overflow-tooltip="true" min-width="80">
            </el-table-column>
            <el-table-column v-if="activeName=='third'" prop="AmountSpent" align="center" label="累计消费" :show-overflow-tooltip="true" min-width="80">
            </el-table-column>
            <el-table-column v-if="activeName=='third'" prop="PayTotalAmount" align="center" label="累计充值" :show-overflow-tooltip="true" min-width="80"></el-table-column>
            <el-table-column prop="proName" align="center" label="操作" :width="activeName=='third' ? '300px' : '200px'">
              <template slot-scope="scope">
                <el-button v-if="activeName=='second'&&(checkPermission(['bgSet_customer_set'],permissionLists))" type="success" size="mini" plain style="margin-right:5px" @click="productSet(scope.row)">产品设置</el-button>
                <el-button v-if="activeName=='second'&&(checkPermission(['bgSet_customer_recharge'],permissionLists))" type="warning" size="mini" plain @click="rechargeHandle(scope.row)" style="margin-right:5px">充值</el-button>
                <el-button v-if="activeName=='third'&&(checkPermission(['bgSet_project_set'],permissionLists))" type="success" size="mini" plain style="margin-right:5px" @click="productSet(scope.row)">产品设置</el-button>
                <el-button v-if="activeName=='third'&&(checkPermission(['bgSet_project_recharge'],permissionLists))" type="warning" size="mini" plain @click="rechargeHandle(scope.row)" style="margin-right:5px">充值</el-button>
                <el-button type="primary" size="mini" plain style="margin-right:5px" v-if="activeName=='third'&&(checkPermission(['bgSet_account_set'],permissionLists))" @click="accountSetHandle(scope.row)">账号设置</el-button>
                <!-- <el-button type="info" size="mini" plain @click="addNewPro" v-if="activeName=='third'">查看</el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-table v-if="activeName=='six'" :data="trialData" style="width: 100%" v-loading="isLoading">
          <el-table-column prop="Name" align="center" label="姓名"></el-table-column>
          <el-table-column prop="Phone" align="center" label="手机号"></el-table-column>
          <el-table-column prop="Email" align="center" label="工作邮箱"></el-table-column>
          <el-table-column prop="CompanyName" align="center" label="公司名称"></el-table-column>
          <el-table-column prop="CreateTime" align="center" label="申请时间">
            <template slot-scope="{row}">
              {{ row.CreateTime ? row.CreateTime.replace('T',' ') : '' }}
            </template>
          </el-table-column>
        </el-table>

        <div class="block" v-if="activeName=='second' || activeName=='third' || activeName=='six'">
          <el-pagination @current-change="changeBPage" :current-page.sync="listQuery.pageNum" :page-size="listQuery.pageSize" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="visiblePackageSet" width="500px" title="项目设置">
      <el-form ref="form" :model="form" label-width="140px">
        <el-form-item label="项目名称">
          <el-input v-model="form.Product"></el-input>
        </el-form-item>
        <el-form-item label="项目单价（元/次）">
          <el-input v-model="form.Price" type="number"></el-input>
        </el-form-item>
        <el-form-item label="是否需要授权">
          <el-radio-group v-model="form.IsAuthorize" @change="
          changeAuthorize">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="认证方式" v-if="form.IsAuthorize==1">
          <el-select v-model="form.a" multiple @change="proWayHandle" placeholder="请选择" style="width:100%">
            <el-option label="姓名+身份证+手机号" value="姓名+身份证+手机号">
            </el-option>
            <!-- <el-option label="姓名+身份证+银行卡" value="姓名+身份证+银行卡">
            </el-option> -->
            <el-option label="人脸识别" value="人脸识别">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目状态">
          <el-radio-group v-model="form.ListingStatus">
            <el-radio :label="1">上架</el-radio>
            <el-radio :label="2">下架</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visiblePackageSet = false">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmSetPro">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="visibleProductSet" width="700px" title="新增产品">
      <el-form ref="ProductForm" :model="ProductForm" label-width="120px">
        <el-form-item label="产品名称">
          <el-input v-model="ProductForm.pro[0].Category"></el-input>
        </el-form-item>
        <div v-for="(item,index) in ProductForm.pro" :key="index" class="mb">
          <el-form-item :label="'项目' + (index + 1) + '名称'">
            <el-input v-model="item.Product"></el-input>
          </el-form-item>
          <el-form-item :label="'项目' + (index + 1) + '余额（元）'">
            <el-input v-model="item.Price" type="number"></el-input>
          </el-form-item>
          <el-form-item label="是否需要授权">
            <el-radio-group v-model="item.IsAuthorize">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="认证方式" v-if="item.IsAuthorize==1">
            <el-select v-model="item.Sort" placeholder="请选择" style="width:100%">
              <el-option label="姓名+身份证+手机号" value="姓名+身份证+手机号">
              </el-option>
              <!-- <el-option label="姓名+身份证+银行卡" value="姓名+身份证+银行卡">
              </el-option> -->
              <el-option label="人脸识别" value="人脸识别">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="txtbtn cp" @click="addProductPro">+新增项目</div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visibleProductSet = false">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmAddProduct">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="visiblePurviewSet" width="700px" title="产品设置">
      <div class="proTitle flex" style="margin-bottom: 10px;">
        <div style="width:320px;padding-left: 30px;">产品</div>
        <div style="width:50px;text-align: center;">单价</div>
        <div style="width:90px;text-align: center;">是否需要授权</div>
        <div style="width:130px;text-align: center;">认证方式</div>
        <div style="width:30px;text-align: center;">设置</div>
      </div>
      <el-tree :data="productList" show-checkbox node-key="Id" :default-checked-keys="checkedList" :default-expand-all="true" :props="defaultProps" @check="handleCheckChange">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <el-tooltip class="item" effect="dark" :content="data.Product" placement="top">
            <span class="product_name text-ellipsis">{{ data.Product }}</span>
          </el-tooltip>
          <span v-if="node.level==2" class="aic">
            <span class="price" style="width: 40px;text-align: center;" v-if="!isNull(data.JbCertProductBusi) && data.JbCertProductBusi != true">￥{{data.JbCertProductBusi.Price}}</span>
            <span class="price" style="width: 40px;text-align: center;" v-else>￥{{data.Price}}</span>
            <span style="width: 90px;text-align: center;" v-if="!isNull(data.JbCertProductBusi) && data.JbCertProductBusi != true"> {{ data.JbCertProductBusi.IsAuthorize == '1' ? '需要授权' : '不需要授权'}}</span>
            <span style="width: 90px;text-align: center;" v-else> {{ data.IsAuthorize == '1' ? '需要授权' : '不需要授权' }}</span>
            <el-tooltip class="item" effect="dark" :content="data.JbCertProductBusi.AuthWay" placement="top" v-if="!isNull(data.JbCertProductBusi) && data.JbCertProductBusi != true">
              <span class="text-ellipsis" style="width: 130px;text-align: center;">{{ data.JbCertProductBusi.IsAuthorize == '1' ? data.JbCertProductBusi.AuthWay : '' }}</span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" :content="data.AuthWay" placement="top" v-else>
              <span class="text-ellipsis" style="width: 130px;text-align: center;">{{ data.IsAuthorize == '1' ? data.AuthWay : '' }}</span>
            </el-tooltip>
            <i class="el-icon-setting" style="margin-left: 15px;line-height: 18px;height: 18px;" title="设置" @click="setProduct(node,data)"></i>
          </span>
        </span>
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visiblePurviewSet = false">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmSaveProductSet">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="visibleBalanceSet" width="450px" title="充值">
      <el-form ref="form2" :model="form2" label-width="100px">
        <el-form-item label="余额">
          {{'￥' + remainingTimes }}
        </el-form-item>
        <el-form-item label="充值类型">
          <!-- <el-select v-model="value" placeholder="请选择" style="width:100%">
            <el-option label="充值" value="充值">
            </el-option>
            <el-option label="调整" value="调整">
            </el-option>
          </el-select> -->
          <el-radio-group v-model="form2.Recharge">
            <el-radio label="充值">充值</el-radio>
            <el-radio label="调整">调整</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="充值（元）">
          <el-input v-model="form2.amount" type="number"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form2.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visibleBalanceSet = false" style="margin-right: 15px;">取 消</el-button>
        <el-popconfirm :title="'请确认是否为' + rechargeName + form2.Recharge + form2.amount + '元'" @confirm="saveRecharge">
          <el-button slot="reference" size="small" type="primary">确 定</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="visibleCustProductInfoSet" width="500px" title="客户特殊项目设置">
      <el-form ref="CPform" :model="info" :rules="CPRules" label-width="140px">
        <el-form-item label="项目名称" prop="Product">
          <el-input v-model="info.Product" readonly :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="项目单价（元/次）" prop="Price">
          <el-input v-model="info.Price" type="number"></el-input>
        </el-form-item>
        <el-form-item label="是否需要授权" prop="IsAuthorize">
          <el-radio-group v-model="info.IsAuthorize">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="认证方式" v-if="info.IsAuthorize==1" prop="AuthWayList">
          <!-- <el-radio-group v-model="info.Sort">
            <el-radio label="姓名+身份证">姓名+身份证</el-radio>
            <el-radio label="姓名+身份证+银行卡">姓名+身份证+银行卡</el-radio>
            <el-radio label="人脸识别">人脸识别</el-radio>
          </el-radio-group> -->
          <el-select v-model="info.AuthWayList" @change="authwayHandle" multiple placeholder="请选择" style="width:100%">
            <el-option label="姓名+身份证+手机号" value="姓名+身份证+手机号">
            </el-option>
            <!-- <el-option label="姓名+身份证+银行卡" value="姓名+身份证+银行卡">
            </el-option> -->
            <el-option label="人脸识别" value="人脸识别">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visibleCustProductInfoSet = false">取 消</el-button>
        <el-button size="small" type="primary" @click="saveProSet">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="visibleAccountSet" width="750px" title="账号设置" class="com_dia_box">
      <el-button type="success" size="mini" style="float: right;" @click="accountAddHandle">新增账号</el-button>
      <el-table :data="gridData">
        <el-table-column property="Name" label="用户名" min-width="100" fit :show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="Tel" label="手机号码" min-width="110" fit :show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="MailStr" label="邮箱" min-width="150" fit :show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="State" label="权限" min-width="100" fit :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <span>{{row.Power}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180px">
          <template slot-scope="{row}">
            <el-button v-if="row.State != 1" type="text" size="small" @click="dredgePermissionHandle(row)">开通权限</el-button>
            <el-button v-if="row.State == 1" type="text" size="small" @click="closePermissionHandle(row)">关闭权限</el-button>
            <el-button type="text" size="small" @click="resetPwdHandle(row)">重置密码</el-button>
            <el-button v-if="row.Disable != 1" type="text" size="small" @click="limitHandle(row)">禁用</el-button>
            <el-button v-if="row.Disable == 1" type="text" size="small" @click="openPowerHandle(row)">启用</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visibleAccountSet = false">取 消</el-button>
        <el-button size="small" type="primary" @click="visibleAccountSet = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="visibleAccountAdd" width="500px" title="新增账号">
      <el-form ref="ruleForm" :rules="rules" :model="Accountform" label-width="100px">
        <el-form-item label="用户名" prop="Name">
          <el-input v-model="Accountform.Name"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="Tel">
          <el-input v-model="Accountform.Tel"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="MailStr">
          <el-input v-model="Accountform.MailStr"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="userPwd">
          <el-input v-model="Accountform.userPwd" type="password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visibleAccountAdd = false">取 消</el-button>
        <el-button size="small" type="primary" @click="saveAddAccount">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import xz from "./../../common.vue";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        activeName: "",
        tableData: [], //闪查产品列表
        form: {
          Id: "",
          Category: "", //产品名称
          Product: "", //项目名称
          Price: "",
          IsDeleted: "",
          IsAuthorize: "", //是否授权
          ListingStatus:1,  //1上架，2下架
          Sort: "", //排序
          AuthWay: "",
          a: [],
        },
        rules: {
          Name: {
            required: true,
            message: "请输入用户名",
            trigger: "blur"
          },
          Tel: {
            required: true,
            message: "请输入手机号码",
            trigger: "blur"
          },
          MailStr: [{
              required: true,
              message: "请输入邮箱",
              trigger: "blur"
            },
            {
              type: "email",
              message: "请输入正确的邮箱地址",
              trigger: ["blur", "change"],
            },
          ],
          userPwd: {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          },
        },
        ProductForm: {
          name: "",
          pro: [{
            Id: "",
            Category: "", //产品名称
            Product: "", //项目名称
            Price: "",
            IsDeleted: false,
            IsAuthorize: "", //是否授权
            Sort: 20, //排序
          }, ],
        },
        customerList: [], //客户列表
        totalCount: 0,
        productList: [], //客户产品列表
        form2: {
          BusiId: "",
          BusiType: "1", //2代表是项目的 1代表是客户
          Recharge: "充值",
          amount: "",
          remark: "",
        },
        isLoading: false,
        checkedList: [], //树节点默认选中列表
        visiblePackageSet: false, //项目设置
        visibleProductSet: false, //产品设置
        visiblePurviewSet: false, //客户权限设置
        visibleBalanceSet: false, //余额设置
        defaultProps: {
          children: "productList",
          label: "Product",
        },
        visibleCustProductInfoSet: false, //设置单个客户 项目单价、授权
        info: {
          Id: "",
          Category: "", //产品名称
          Product: "", //项目名称
          Price: "",
          IsDeleted: "",
          IsAuthorize: "", //是否授权
          Sort: "", //排序
          AuthWay: "",
          AuthWayList: [],
        },
        AuthWay: [],
        BusiId: "", //客户id
        visibleAccountSet: false, //账号设置
        visibleAccountAdd: false, //新增账号
        gridData: [], //账号表格
        Accountform: {
          Id: "",
          Name: "",
          Tel: "",
          MailStr: "",
          Ramark: "",
          userPwd: "",
          Disable: 0, //0未禁用 1禁用
          State: 0, //0未开通权限 1已开通闪查权限
          CertCustomId: "", //企业id
        },
        listQuery: {
          pageNum: 1,
          pageSize: 10,
          name: "",
        },
        remainingTimes: 0,
        rechargeName: "", //充值的公司名称
        isRecharge: false, //是否在充值中
        // 按钮权限参数
        butQuery: {
          path: '/bgSet',
          powerEnName: 'product'
        },
        permissionLists: [],
        CPRules: {
          Product: {
            required: true,
            message: '请填写项目名称',
            trigger: 'blur'
          },
          Price: {
            required: true,
            message: '请填写项目单价',
            trigger: 'blur'
          },
          IsAuthorize: {
            required: true,
            message: '请选择是否需要授权',
            trigger: 'change'
          },
          AuthWayList: {
            required: true,
            message: '请选择认证方式',
            trigger: 'change'
          },
          thirdLoading: false,
        },
        trialData: []
      };
    },
    created() {
      this.getButtonPower()
    },
    mounted() {},
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        let actives = this.$route.query.activeName;
        xz.getbtnPowerIdBypage(this.butQuery).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                that.permissionLists.push(element.Enname);
              }
              if (!that.isNull(actives)) {
                that.activeName = actives
                if (that.activeName == "second") {
                  that.getprojectlist();
                } else if (that.activeName == "first") {
                  that.getcertmenu();
                } else if (that.activeName == "third") {
                  that.getprojectlist();
                } else if (that.activeName == "four") {
                  that.$router.push({
                    path: '/consumerDetails',
                    query: {
                      activeName: 'four'
                    }
                  })
                } else if (that.activeName == "five") {
                  that.$router.push({
                    path: '/allCustomManage',
                    query: {
                      activeName: 'five'
                    }
                  })
                } else if (that.activeName == "six") {
                  that.getTrialSubmitList();
                }
              } else {
                if (that.checkPermission(['bgSet_customer_manage'], that.permissionLists)) {
                  that.activeName = 'third'
                  that.getprojectlist();
                } else if ((!that.checkPermission(['bgSet_customer_manage'], that.permissionLists)) && (that.checkPermission(['bgSet_project_manage'], that.permissionLists))) {
                  that.activeName = 'second'
                  that.getprojectlist();
                } else if ((!that.checkPermission(['bgSet_customer_manage'], that.permissionLists)) && (!that.checkPermission(['bgSet_project_manage'], that.permissionLists)) && (that.checkPermission(['bgSet_product_manage'], that.permissionLists))) {
                  that.activeName = 'first'
                  that.getcertmenu();
                }
              }
            } else {
              this.permissionLists = []
              this.activeName = ''
            }
          } else {
            this.permissionLists = []
            this.activeName = ''
          }
        })
      },
      // 选择认证方式
      authwayHandle(val) {
        if (!this.isNull(val)) {
          this.info.AuthWay = val.toString();
        } else {
          this.info.AuthWay = "";
        }
      },
      handleClick(tab, event) {
        // console.log(tab, event);
        let that = this
        this.activeName = '';
        setTimeout(() => {
          this.activeName = tab.name;
          this.listQuery = {
            pageNum: 1,
            pageSize: 10,
            name: "",
          }
          if (tab.name == "second") {
            this.getprojectlist();
          } else if (tab.name == "first") {
            this.getcertmenu();
          } else if (tab.name == "third") {
            this.getprojectlist();
          } else if (tab.name == "four") {
            that.$router.push({
              path: '/consumerDetails',
              query: {
                activeName: 'four'
              }
            })
          } else if (tab.name == "five") {
            that.$router.push({
              path: '/allCustomManage',
              query: {
                activeName: 'five'
              }
            })
          } else if (tab.name == "six") {
            this.getTrialSubmitList();
          }
        }, 100);
      },
      //获取申请试用列表
      getTrialSubmitList() {
        this.isLoading = true;
        xz.getTrialSubmitList(this.listQuery).then(res => {
          if (res.status == "ok") {
            this.isLoading = false;
            this.trialData = res.data.RetList;
            this.totalCount = res.data.totalCount;
          } else {
            this.trialData = [];
            this.isLoading = false;
          }
        })
      },
      exportListTrial() {
        this.isLoading = true;
        let data = {
          pageNum: 1,
          pageSize: 10000,
          IsExport: 1
        }
        xz.getTrialSubmitList(data).then(res => {
          if (res.status == "ok") {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a");
            aLink.download = '申请试用列表.xls' //这里写保存时的图片名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.isLoading = false;
          } else {
            this.$message.error('导出失败')
            this.isLoading = false;
          }
        })
      },
      //开通权限
      dredgePermissionHandle(row) {
        let data = {
          Id: row.Id,
          Name: row.Name,
          Tel: row.Tel,
          MailStr: row.MailStr,
          Ramark: row.Ramark,
          Disable: row.Disable, //0未禁用 1禁用
          State: 1, //0未开通权限 1已开通闪查权限
          CertCustomId: row.CertCustomId, //企业id
        };
        this.editAccount(data);
      },
      //关闭权限
      closePermissionHandle(row) {
        let data = {
          Id: row.Id,
          Name: row.Name,
          Tel: row.Tel,
          MailStr: row.MailStr,
          Ramark: row.Ramark,
          Disable: row.Disable, //0未禁用 1禁用
          State: 0, //0未开通权限 1已开通闪查权限
          CertCustomId: row.CertCustomId, //企业id
        };
        this.editAccount(data);
      },
      //重置密码
      resetPwdHandle(row) {
        xz.updatauserpwd({
          userid: row.Id,
          pwd: ''
        }).then((res) => {
          // console.log('确定新增账号', res)
          if (res.status == "ok") {
            this.$message.success("操作成功");
            this.getcustomeruser(this.Accountform.CertCustomId);
          } else {
            this.$message.error("操作失败，请稍后再试。");
          }
        });
      },
      //禁用
      limitHandle(row) {
        let data = {
          Id: row.Id,
          Name: row.Name,
          Tel: row.Tel,
          MailStr: row.MailStr,
          Ramark: row.Ramark,
          Disable: 1, //0未禁用 1禁用
          State: row.State, //0未开通权限 1已开通闪查权限
          CertCustomId: row.CertCustomId, //企业id
        };
        this.editAccount(data);
      },
      //启用
      openPowerHandle(row) {
        let data = {
          Id: row.Id,
          Name: row.Name,
          Tel: row.Tel,
          MailStr: row.MailStr,
          Ramark: row.Ramark,
          Disable: 0, //0未禁用 1禁用
          State: row.State, //0未开通权限 1已开通闪查权限
          CertCustomId: row.CertCustomId, //企业id
        };
        this.editAccount(data);
      },
      // 修改账号
      editAccount(item) {
        xz.updatacustomeruser(item).then((res) => {
          // console.log('确定新增账号', res)
          if (res.status == "ok") {
            this.$message.success("操作成功");
            this.getcustomeruser(this.Accountform.CertCustomId);
            this.visibleAccountAdd = false;
          } else {
            this.$message.error("操作失败，请稍后再试。");
          }
        });
      },
      // 搜索
      searchHandle() {
        this.listQuery.pageNum = 1;
        this.getprojectlist();
      },
      // 充值弹框
      rechargeHandle(item) {
        console.log("EE", item);
        this.form2.amount = "";
        this.form2.remark = "";
        if (this.activeName == "second") {
          this.form2.BusiType = "2";
          this.form2.BusiId = item.Projectid;
          this.getNumData(item.Projectid, "2");
          this.rechargeName = item.StrprojectName;
        } else if (this.activeName == "third") {
          this.form2.BusiType = "1";
          this.form2.BusiId = item.Id;
          this.getNumData(item.Id, "1");
          this.rechargeName = item.ShortName;
        }
        this.visibleBalanceSet = true;
      },
      // 确定充值
      saveRecharge() {
        if (this.isRecharge) {
          return
        } else {
          let that = this;
          if (this.isNull(that.form2.amount)) {
            this.$message.warning(
              this.activeName == "third" ? "请输入充值金额" : "请输入充值次数"
            );
          } else {
            this.isRecharge = true;
            xz.walletrechargeadjustment(that.form2).then((res) => {
              if (res.status == "ok") {
                this.$message.success("操作成功");
                this.visibleBalanceSet = false;
                this.getprojectlist();
              } else {
                this.$message.error("操作失败，请稍后再试。");
              }
              this.isRecharge = false;
            });
          }
        }

      },
      // 获取工作台 次数
      getNumData(id, type) {
        let that = this;
        let query = {
          BusiId: id,
          BusiType: type,
        };
        xz.getworkingdisplaystation(query).then((res) => {
          // console.log('项目名称列表', res)
          if (res.status == "ok") {
            if (!this.isNull(res.data)) {
              that.remainingTimes = res.data.Amount;
            } else {
              that.remainingTimes = 0;
            }
          } else {
            that.remainingTimes = 0;
          }
        });
      },
      // 新增账号
      accountAddHandle() {
        this.visibleAccountAdd = true;
      },
      // 确定新增账号
      saveAddAccount() {
        let that = this;
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            xz.updatacustomeruser(that.Accountform).then((res) => {
              // console.log('确定新增账号', res)
              if (res.status == "ok") {
                this.$message.success("操作成功");
                this.getcustomeruser(this.Accountform.CertCustomId);
                this.visibleAccountAdd = false;
              } else {
                this.$message.error("操作失败，请稍后再试。");
              }
            });
          }
        });
      },
      // 账号设置弹框
      accountSetHandle(item) {
        this.visibleAccountSet = true;
        this.Accountform.CertCustomId = item.Id;
        this.getcustomeruser(item.Id);
      },
      // 获取个客户下所有的账号
      getcustomeruser(id) {
        let that = this;
        xz.getcustomeruser(id).then((res) => {
          // console.log('所有的账号', res)
          if (res.status == "ok") {
            this.gridData = res.data;
          } else {
            this.gridData = [];
          }
        });
      },
      //获取内部项目列表
      getprojectlist() {
        if (this.activeName == "second") {
          this.isLoading = true;
          xz.getprojectlist(this.listQuery).then((res) => {
            if (res.status == "ok") {
              this.customerList = res.data.list;
              this.totalCount = res.data.totalCount;
            } else {
              this.customerList = [];
            }
            this.isLoading = false;
          });
        } else if (this.activeName == "third") {
          this.isLoading = true;
          xz.getcustomer(this.listQuery).then((res) => {
            if (res.status == "ok") {
              this.customerList = res.data.RetList;
              this.totalCount = res.data.totalCount;
            } else {
              this.customerList = [];
            }
            this.isLoading = false;
          });
        } else if (tab.name == "first") {
          this.getcertmenu();
        }
      },
      //导出列表
      exportList() {
        let data = {
          name: this.listQuery.name,
          pageNum: this.listQuery.pageNum,
          pageSize: this.listQuery.pageSize,
          IsExport: 1
        }
        xz.getcustomer(data).then((res) => {
          if (res.status == "ok") {
            console.log(res.data)
            if (res.data != undefined) {
              let url = res.data;
              let base64 = url.toString()
              let byteCharacters = atob(
                base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
              )
              let byteNumbers = new Array(byteCharacters.length)
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
              }
              let byteArray = new Uint8Array(byteNumbers)
              let blob = new Blob([byteArray], {
                type: `application/pdf`
              })
              let aLink = document.createElement("a");
              aLink.download = '客户列表.xls' //这里写保存时的名称
              aLink.href = URL.createObjectURL(blob)
              aLink.click()
            }
          } else {
            this.$message.error('导出失败')
          }
        });
      },
      //翻页
      changeBPage(val) {
        this.listQuery.pageNum = val;
        if (this.activeName == 'six') {
          this.getTrialSubmitList();
        } else {
          this.getprojectlist();
        }
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        if (this.activeName == 'six') {
          this.getTrialSubmitList();
        } else {
          this.getprojectlist();
        }
      },
      //产品设置
      productSet(item) {
        let data = {};
        // console.log('dd',item)
        if (this.activeName == "third") {
          data = {
            BusiId: item.Id,
            BusiType: this.activeName == "third" ? "1" : "2",
          };
          this.BusiId = item.Id;
        } else {
          data = {
            BusiId: item.Projectid,
            BusiType: this.activeName == "third" ? "1" : "2",
          };
          this.BusiId = item.Projectid;
        }
        xz.getcertproductbusi(data).then((res) => {
          if (res.status == "ok") {
            this.productList = res.data;
            this.checkedList = [];
            this.productList.forEach((element) => {
              this.$set(element, "Product", element.name);
              this.$set(
                element,
                "Id",
                new Date().valueOf().toString() + Math.random()
              );
              element.productList.forEach((ele) => {
                if (ele.JbCertProductBusi) {
                  this.checkedList.push(ele.Id);
                }
              });
            });
          } else {
            this.productList = [];
          }
        });
        this.visiblePurviewSet = true;
      },
      // 删除闪查产品
      dltPro(row) {
        let that = this;
        console.log("ff", row);
        // this.$confirm('是否删除此数据?', '提示', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        //   }).then(() => {
        //     xz.updatacertmenu(that.form).then((res) => {
        //       if (res.status == "ok") {
        //         that.$message.success("操作成功！");
        //         that.getcertmenu();
        //       }else{
        //         that.$message.error("操作失败,请稍后再试！");
        //       }
        //     });
        //   }).catch(() => {
        //     console.log('已取消')
        // })
      },
      //获取闪查产品管理列表
      getcertmenu() {
        this.isLoading = true;
        xz.getMenuProduct("").then((res) => {
          // console.log(res);
          if (res.status == "ok") {
            this.tableData = res.data;
            this.tableData.forEach((element) => {
              this.$set(element, "Product", element.name);
            });
          } else {
            this.$message.error("系统出错");
            this.tableData = [];
          }
          this.isLoading = false
        });
      },
      // //获取闪查产品项目内容列表
      // getcertmenu() {
      //   xz.getcertmenu(this.menuQuery).then((res) => {
      //     console.log(res);
      //     if (res.status == "ok") {
      //       this.tableData = res.data;
      //       this.tableData.forEach((element) => {
      //         this.$set(element, "Product", element.name);
      //       });
      //     } else {
      //       this.$message.error("系统出错");
      //       this.tableData = [];
      //     }
      //   });
      // },
      //项目设置
      setPro(item, row) {
        // console.log('ff',item, row)
        this.form.Id = item.Id;
        this.form.AuthWay = item.AuthWay;
        this.form.Product = item.Product;
        this.form.Price = item.Price;
        this.form.Sort = item.Sort;
        this.form.IsDeleted = item.IsDeleted;
        this.form.IsAuthorize = Number(item.IsAuthorize);
        this.form.ListingStatus = Number(item.ListingStatus);
        this.form.Category = row.name;
        if (!this.isNull(item.AuthWay)) {
          this.form.a = item.AuthWay.split(",");
        } else {
          this.form.a = [];
        }
        this.visiblePackageSet = true;
      },
      proWayHandle(val) {
        // console.log('rr',val)
        this.form.a = val;
        if (!this.isNull(val)) {
          this.form.AuthWay = val.toString();
        } else {
          this.form.AuthWay = "";
        }
      },
      saveProSet() {
        this.$refs["CPform"].validate((valid) => {
          if (valid) {
            let that = this;
            this.productList.forEach((element) => {
              if (that.info.Category == element.name) {
                element.productList.forEach((ele) => {
                  if (ele.Product == this.info.Product) {
                    if (ele.JbCertProductBusi && ele.JbCertProductBusi != true) {
                      // this.$set(
                      //   ele.JbCertProductBusi,
                      //   "AuthWay",
                      //   this.AuthWay.join(",")
                      // );
                      that.$set(ele.JbCertProductBusi, "AuthWay", that.info.AuthWay);
                      that.$set(
                        ele.JbCertProductBusi,
                        "IsAuthorize",
                        that.info.IsAuthorize
                      );
                      that.$set(ele.JbCertProductBusi, "Price", that.info.Price);
                    }
                    // this.$set(ele, "AuthWay", this.AuthWay.join(","));
                    that.$set(ele, "AuthWay", this.info.AuthWay);
                    that.$set(ele, "IsAuthorize", this.info.IsAuthorize);
                    that.$set(ele, "Price", this.info.Price);
                    that.visibleCustProductInfoSet = false;
                    // console.log(that.productList, ele);
                  }
                });
              }
            });
          }
        })

      },
      //勾选树节点
      handleCheckChange(data, checkData) {
        this.$set(
          data,
          "JbCertProductBusi",
          data.JbCertProductBusi ? false : true
        );
        if (data.productList != undefined) {
          let A = data.productList.some(
            (ele) => ele.JbCertProductBusi != undefined && ele.JbCertProductBusi
          );
          let B = data.productList.some((ele) => !ele.JbCertProductBusi);
          data.productList.forEach((element) => {
            this.$set(
              element,
              "JbCertProductBusi",
              A && B ? true : !A && B ? true : A && !B ? false : ""
            );
          });
          console.log(data.productList);
        }
        //   console.log(data)
        // }
      },
      //保存客户的产品权限设置
      confirmSaveProductSet() {
        let arr = [];
        this.productList.forEach((element) => {
          element.productList.forEach((ele) => {
            if (ele.JbCertProductBusi) {
              if (ele.JbCertProductBusi == true) {
                let data = {
                  Id: "",
                  Category: element.name,
                  Product: ele.Product,
                  Price: ele.Price,
                  IsAuthorize: ele.IsAuthorize,
                  Sort: ele.Sort,
                  AuthWay: ele.AuthWay,
                  BusiId: this.BusiId,
                  ProductId: ele.Id,
                  BusiType: this.activeName == "third" ? "1" : "2",
                };
                arr.push(data);
              } else {
                let data = {
                  Id: ele.JbCertProductBusi.Id,
                  Category: element.name,
                  Product: ele.Product,
                  Price: ele.JbCertProductBusi.Price,
                  IsAuthorize: ele.JbCertProductBusi.IsAuthorize,
                  Sort: ele.Sort,
                  AuthWay: ele.JbCertProductBusi.AuthWay,
                  BusiId: this.BusiId,
                  ProductId: ele.Id,
                  BusiType: this.activeName == "third" ? "1" : "2",
                };
                arr.push(data);
              }
            }
          });
        });
        if (arr.length == 0) {
          arr = {
            BusiId: this.BusiId,
            BusiType: this.activeName == "third" ? "1" : "2",
          };
        }
        setTimeout(() => {
          xz.updatacertproductbusi(arr).then((res) => {
            if (res.status == "ok") {
              this.$message.success("保存成功");
            } else {
              this.$message.error("系统出错");
            }
          });
          this.visiblePurviewSet = false;
        }, 100);
      },
      //新增/修改项目
      confirmSetPro() {
        xz.updatacertmenu([this.form]).then((res) => {
          if (res.status == "ok") {
            this.$message.success("保存成功！");
            this.getcertmenu();
            this.visiblePackageSet = false;
          } else {
            this.$message.error("操作失败,请稍后再试！");
          }
        });
      },
      //新增项目
      addNewPro(row) {
        this.form = {
          Id: "",
          Category: "",
          Product: "",
          Price: "",
          IsDeleted: false,
          IsAuthorize: "",
          Sort: 20,
        };
        this.form.Category = row.name;
        this.visiblePackageSet = true;
      },
      addProductPro() {
        this.ProductForm.pro.push({
          Id: "",
          Category: this.ProductForm.pro[0].Category, //产品名称
          Product: "", //项目名称
          Price: "",
          IsDeleted: false,
          IsAuthorize: "", //是否授权
          Sort: 20, //排序
        });
      },
      confirmAddProduct() {
        let data = this.ProductForm.pro;
        xz.updatacertmenu(data).then((res) => {
          if (res.status == "ok") {
            this.$message.success("保存成功！");
            this.getcertmenu();
            this.visibleProductSet = false;
          }
        });
      },
      setProduct(node, item) {
        // console.log(node, item);
        let a = !this.isNull(item.JbCertProductBusi) && item.JbCertProductBusi != true;
        this.info.Id = item.Id;
        this.info.Product = item.Product;
        this.info.Price = a ? item.JbCertProductBusi.Price : item.Price;
        this.info.Sort = item.Sort;
        this.info.AuthWay = a ? item.JbCertProductBusi.AuthWay : item.AuthWay;
        this.info.AuthWayList = a ?
          !this.isNull(item.JbCertProductBusi.AuthWay) ?
          item.JbCertProductBusi.AuthWay.split(",") : [] :
          !this.isNull(item.AuthWay) ?
          item.AuthWay.split(",") : [];
        this.info.IsDeleted = item.IsDeleted;
        this.info.IsAuthorize = a ?
          Number(item.JbCertProductBusi.IsAuthorize) :
          Number(item.IsAuthorize);
        this.info.Category = node.parent.data.name;
        this.visibleCustProductInfoSet = true;
      },
      addNewCust() {
        const routerUrl = this.$router.resolve({
          path: "/addNewCust",
        });
        window.open(routerUrl.href, "_blank");
      },
      isNull(o) {
        // console.log('isnull',o)
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN"
        );
      },
      changeAuthorize(val) {
        console.log(val)
        if (val == 1) {
          this.info.AuthWay = '姓名+身份证+手机号,人脸识别';
          this.info.AuthWayList = ['姓名+身份证+手机号', '人脸识别']
        }
      }
    },
  };
</script>
<style scoped>
  .bgset_btn {
    display: flex;
    justify-content: flex-end;
  }

  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    width: 98%;
    margin-bottom: 16px;
  }

  .packageBox {
    display: flex;
  }

  .packageItem {
    height: 236px;
    width: 300px;
    margin-right: 15px;
    background: #f7f7f7;
    position: relative;
  }

  .packageTitle {
    width: 100%;
    text-align: center;
    background-color: #eee;
    font-weight: 700;
    height: 36px;
    line-height: 36px;
    margin-bottom: 10px;
  }

  .dd {
    line-height: 30px;
    height: 30px;
    padding-left: 10px;
  }

  .el-icon-setting {
    /* position: absolute;
  top: 9px;
  right: 15px; */
    font-size: 18px;
    line-height: 34px;
    margin-right: 15px;
  }

  .proName {
    font-weight: 700;
    font-size: 14px;
    margin-left: 15px;
  }

  .contentTips {
    font-size: 14px;
    margin-top: 10px;
    margin-left: 15px;
  }

  .icon {
    width: 16px;
    height: 16px;
    margin: 0 10px;
  }

  .selectedbc {
    background: #19bd92;
    color: #fff;
  }

  .checkBox {
    flex-wrap: wrap;
  }

  .checkItem {
    background: #f0f0f0;
    color: #495060;
    height: 34px;
    line-height: 20px;
    width: calc(33% - 20px);
    /* max-width: 300px; */
    margin-right: 10px;
    font-size: 13px;
    /* overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow:ellipsis; */
  }

  .txtbtn {
    width: 108px;
    text-align: right;
    color: #19bd92;
  }

  .price {
    color: #f60;
    margin-left: 15px;
  }

  .mt {
    margin-top: 10px;
  }

  .mb {
    padding-top: 20px;
    border-top: 1px dashed #ccc;
  }

  .custom-tree-node {
    height: 18px;
    line-height: 18px;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .proTitle {
    font-size: 14px;
    font-weight: 550;
  }

  .text-ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }

  .product_name {
    width: 240px;
  }
</style>
<style>
  .com_dia_box .el-table .el-table__cell {
    padding: 0;
  }

  /* .page_backgroundCheckRecord .el-tooltip__popper{
  max-width: 500px;
} */
  .el-tooltip__popper {
    max-width: 800px !important;
  }

  .page_backgroundCheckRecord .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_backgroundCheckRecord .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }
</style>